import configApi from '@/api/config';

const state = {
    isLoading: false,
    validationErrors: null,
    config:null
}

export const mutationTypes = {
    getConfigStart: '[config] Get config start',
    getConfigSuccess: '[config] Get config success',
    getConfigFailure: '[config] Get config failure',
}

export const configActionTypes = {
    getConfig: '[config] Get config'
}

const mutations = {
    [mutationTypes.getConfigStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getConfigSuccess](state, payload) {
        state.isLoading = false
        state.config = payload
        state.validationErrors = null
    },
    [mutationTypes.getConfigFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [configActionTypes.getConfig](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getConfigStart)
            configApi
                .getConfig(data)
                .then(response => {
                    context.commit(mutationTypes.getConfigSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getConfigFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}